import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import StateMatrix from './pages/StateMatrix';
import LicenseRegister from './pages/LicenseRegister';
import DBARegister from './pages/DBARegister';
import FilingsRegister from './pages/FilingsRegister';
import RegisteredAgents from './pages/RegisteredAgents';
import ExpenseTrackerEnhanced from './pages/ExpenseTrackerEnhanced';
import TasksCalendarView from './pages/TasksCalendarView';
import DocumentManagementSystem from './pages/DocumentManagementSystem';
import AuditLog from './pages/AuditLog';
import Settings from './pages/Settings';
import AppShell from './components/AppShell';
import { Toaster } from './components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <Router>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <div className="app-noise">
        <Toaster position="top-right" richColors />
        <AppShell user={user} onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<Dashboard user={user} />} />
            <Route path="/states" element={<StateMatrix user={user} />} />
            <Route path="/licenses" element={<LicenseRegister user={user} />} />
            <Route path="/dbas" element={<DBARegister user={user} />} />
            <Route path="/filings" element={<FilingsRegister user={user} />} />
            <Route path="/registered-agents" element={<RegisteredAgents user={user} />} />
            <Route path="/expenses" element={<ExpenseTrackerEnhanced user={user} />} />
            <Route path="/tasks" element={<TasksCalendarView user={user} />} />
            <Route path="/calendar" element={<Navigate to="/tasks" replace />} />
            <Route path="/documents" element={<DocumentManagementSystem user={user} />} />
            <Route path="/audit" element={<AuditLog user={user} />} />
            <Route path="/settings" element={<Settings user={user} />} />
            {/* Redirect old entity-registry route to settings */}
            <Route path="/entities" element={<Navigate to="/settings" replace />} />
            <Route path="/entity-registry" element={<Navigate to="/settings" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppShell>
      </div>
    </Router>
  );
}

export default App;
